/*
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2016-2020 Michael Purcaro, Henry Pratt, Jill Moore, Zhiping Weng
 */

/* -*- mode: javascript; c-basic-offset: 4; indent-tabs-mode: nil -*- */

// 
// Dalliance Genome Explorer
// (c) Thomas Down 2006-2010
//
// das.js: queries and low-level data model.
//


//
// DAS 1.6 features command
//

export function DASFeature() {
}

export function DASGroup(id) {
    if (id)
        this.id = id;
}



// WEBPACK FOOTER //
// ./src/common/components/genomebrowser/external/igvjs/das.js